const LOAD_URL = '/advert/review/list/load';

const API_REVIEW_LIST_NAME = 'apiReviewList';

export {
  LOAD_URL,

  API_REVIEW_LIST_NAME,
};
